import React from "react";

const NotFoundScreen: React.FC = () => {
    return <div>
        NotFound
    </div>;
};

export default NotFoundScreen;
